import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, AlertController, ToastController, ModalController } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
import * as moment from 'moment'
import { CalendarPage } from '../../calendar/calendar';
import { AlertsaddPage } from '../alerts/alertsadd';
import { EditdrivergradePage } from './editdrivergrade/editdrivergrade';
import { EditvehshiftsPage } from '../editvehshifts/editvehshifts';
import { PopupPage } from '../../popup/popup';
import { ExcludearmPage } from '../../excludearm/excludearm';
import { PopupadddriverPage } from './popupadddriver/popupadddriver';

/**
 * Generated class for the LinkvehicletruckingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-linkvehicletrucking',
  templateUrl: 'linkvehicletrucking.html',
})
export class LinkvehicletruckingPage {
  vehicle = ''
  VehicleID = -1
  _email: string = ''
  _expiredt = moment().format(this.gn.user.DFormat)
  _expiredtYMD = moment().format('YYYY-MM-DD')
  _expiredtYMDStr: any = moment().format('DD-MM-YYYY')
  selectedTime = new Date().getHours() + 1 + ":00";
  linkTab: string = 'newlink'
  _hData = []
  _edit = false;
  _editid = -1;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public toastCtrl: ToastController, public modalCtrl: ModalController) {
    this.vehicle = navParams.get('vehicle')
    this.VehicleID = navParams.get('vehicleid')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LinkvehicletruckingPage');
  }

  openDatePopup(_ev) {
    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: _that._expiredtYMD, cb: function (d) {
        _that._expiredt = d;
        _that._expiredtYMD = moment(_that._expiredt).format('YYYY-MM-DD')
        _that._expiredtYMDStr = moment(_that._expiredt).format('DD-MM-YYYY')
      }
    })
    popover.present({ ev: _ev });
  }

  openTimePopup(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'timeassignment', selected: [], callback: function (_text, _ids) {
        _that.selectedTime = _text;
      }
    });
    popover.present({
      ev: _ev
    });
  }

  cancel() {
    if (this._edit == true) {
      this.linkTab = 'history';
      this._edit = false;
      this._editid = -1;
    } else {
      this.navCtrl.pop()
    }
  }
  Save() {
    this.gn.tfBtn = true;
    if (!this.validateEmail(this._email)) {
      let toast = this.toastCtrl.create({ message: this.dic.l["entervalidemail"], duration: 3000, position: 'top' });
      toast.present();
      return
    } else {
      if (moment(this._expiredtYMD + ' ' + this.selectedTime + ':00') < moment(new Date())) {
        let toast = this.toastCtrl.create({ message: this.dic.l["moreThanToday"], duration: 3000, position: 'top' });
        toast.present();
        return
      } else {
        var _that = this

        if (this._edit == true) {
          this.gn._Post('/api/gn/deletelivelink', { id: this.gn.crypt(this._editid) }, function (_data) {
            _that.gn._Post('/api/gn/makelivelink', { cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId), email: _that.gn.crypt(_that._email), lang: _that.gn.crypt(_that.dic.Lang), expiredtstr: _that.gn.crypt(_that._expiredtYMDStr + ' ' + _that.selectedTime), expiredt: _that.gn.crypt(_that._expiredtYMD + ' ' + _that.selectedTime), veh: _that.gn.crypt(_that.vehicle), vehid: _that.gn.crypt(_that.VehicleID), }, function (_data) {
              _that.gn.tfBtn = false;
              var _cb = _that.navParams.get('cb')
              _cb()
              _that.navCtrl.pop()

            })
          })
        } else {
          this.gn._Post('/api/gn/makelivelink', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), email: this.gn.crypt(this._email), lang: this.gn.crypt(this.dic.Lang), expiredtstr: this.gn.crypt(this._expiredtYMDStr + ' ' + this.selectedTime), expiredt: this.gn.crypt(this._expiredtYMD + ' ' + this.selectedTime), veh: this.gn.crypt(this.vehicle), vehid: this.gn.crypt(this.VehicleID), }, function (_data) {
            _that.gn.tfBtn = false;
            var _cb = _that.navParams.get('cb')
            _cb()
            _that.navCtrl.pop()

          })
        }
      }
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  changeSegments(name) {
    this._hData = []
    var _that = this
    if (name == 'newlink') {
      this.linkTab = 'newlink'
      this.resetVariables()
    }
    if (name == 'editlink') {
      this.linkTab = 'editlink'
    }
    if (name == 'history') {
      this.linkTab = 'history'
      this.resetVariables()
      this.loadHistory()
    }

  }

  loadHistory() {
    var _that = this
    this.gn._Post('/api/gn/getlivelinkhistory', { cid: this.gn.crypt(this.gn.user.ClientId), vehid: this.gn.crypt(this.VehicleID) }, function (_data) {
      _that._hData = _data
      for (var i = 0; i < _that._hData.length; i++) {
        _that._hData[i].expires1 = moment(_that._hData[i].expires)
        _that._hData[i].expiresymd = moment(_that._hData[i].expires).format('YYYY-MM-DD')
        _that._hData[i].expiresdmy = moment(_that._hData[i].expires).format('DD-MM-YYYY')

        _that._hData[i].expirest = moment(_that._hData[i].expires).format('HH:mm')
        _that._hData[i].expires = moment(_that._hData[i].expires).format(_that.gn.user.DFormat) + ' ' + moment(_that._hData[i].expires).format('HH:mm')
      }
    })
  }

  EditLink(_l) {
    if (_l.olddt == '1') {
      return false;
    } else {
      this._edit = true;
      this._editid = _l.id;

      this.linkTab = 'editlink'
      this._email = _l.email

      this._expiredt = _l.expires1;
      this._expiredtYMD = _l.expiresymd
      this._expiredtYMDStr = _l.expiresdmy

      this.selectedTime = _l.expirest
    }
  }

  DeleteLink(_l) {
    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deletelink"],
      subTitle: _that.dic.l["areyousuredellink"],
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn._Post('/api/gn/deletelivelink', { id: _that.gn.crypt(_l.id) }, function (_data) {
              _that.loadHistory()
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

  resetVariables() {
    this._edit = false
    this._editid = -1
    this._email = ''
    this._expiredt = moment().format(this.gn.user.DFormat)
    this._expiredtYMD = moment().format('YYYY-MM-DD')
    this._expiredtYMDStr = moment().format('DD-MM-YYYY')
    this.selectedTime = new Date().getHours() + 1 + ":00";
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/vehiclesettinngs/linkvehicletrucking.ts